var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"Z79IFAgroUha7BE3zn4Ey"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["accred-frontend@uniqsoft"]={id:"Z79IFAgroUha7BE3zn4Ey"};
      